import * as React from 'react';
import styles from './SantaShowcaseSwitcher.scss';
import classNames from 'classnames';
import { ICurrentPage } from '~/Actions/ActionAppType';
import { State } from '~/Reducers';
import { useSelector } from 'react-redux';
import equal from 'fast-deep-equal/react';
import { CATEGORIES } from '~/const';
import { openCategoryByName } from '~/utils/category';
import { t } from '~/utils/localization';
import { settings } from '~/utils/settings';
import { isAvailableSwitcherBetweenSantaCategories } from '~/Layouts/Themes/SantaPage/settings';

interface ISantaShowcaseSwitcher {
    className?: string;
}

interface IStateSelector {
    currentPage: ICurrentPage;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        currentPage: state.ReducerApp.currentPage,
    };
};

const SantaShowcaseSwitcher = ({ className }: ISantaShowcaseSwitcher) => {
    const state = useSelector<State, IStateSelector>(stateSelector, equal);
    const isAvailableSwitcher = isAvailableSwitcherBetweenSantaCategories(state.currentPage?.name);
    const isGoldPage = state.currentPage?.name === CATEGORIES.SANTA_CONTAINERS;

    if (!isAvailableSwitcher || state.currentPage?.isBundlePage) {
        return null;
    }

    const onClick = () => {
        if (state.currentPage?.name === CATEGORIES.SANTA_CONTAINERS) {
            openCategoryByName(CATEGORIES.SANTA_CERTIFICATES);
        } else {
            openCategoryByName(CATEGORIES.SANTA_CONTAINERS);
        }
    };

    const classesWrapper = classNames(
        styles.wrapper,
        {
            [styles.isCertificate]: !isGoldPage,
        },
        styles[settings.realm],
        className,
    );

    return (
        <div className={classesWrapper} onClick={onClick}>
            <div className={styles.icon} />
            <div className={styles.label}>{isGoldPage ? t('Обменять Новогодние сертификаты') : t('Купить Новогодние подарки')}</div>
        </div>
    );
};

export default SantaShowcaseSwitcher;
